import script from "./UserMgmtPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMgmtPage.vue?vue&type=script&setup=true&lang=js"

import "./UserMgmtPage.vue?vue&type=style&index=0&id=65ae37fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ae37fa"]])

export default __exports__